export default __webpack_public_path__ + "static/media/info-icon.f8a12d34.svg";